import { forwardRef, ChangeEvent } from 'react';
import type { ModifierKeys } from 'styled-components-modifiers';

// Import styles
import { Label, Input, CustomError, Wrapper } from './styles';
import { CheckboxContent } from './CheckboxContent';

type Props = {
	disabled?: boolean;
	checked: boolean;
	value?: string | number;
	name: string;
	required?: boolean;
	label: string | JSX.Element | JSX.Element[];
	isError?: boolean;
	modifiers?: ModifierKeys | undefined;
	customError?: string | null;
	indented?: boolean;
	showIsOptional?: boolean;
	onChange: (e: ChangeEvent<HTMLInputElement>) => void;
};

const Checkbox = forwardRef<HTMLInputElement, Props>(
	(
		{ disabled = false, checked, value, name, required, label, isError, modifiers, customError, indented = false, showIsOptional = true, onChange },
		ref
	) => (
		<Wrapper customError={!!customError}>
			<Label disabled={disabled}>
				<Input disabled={disabled} type="checkbox" checked={checked} onChange={onChange} value={value} name={name} ref={ref} modifiers={modifiers} />
				<CheckboxContent
					label={label}
					isError={isError}
					required={required}
					modifiers={modifiers}
					indented={indented}
					showIsOptional={showIsOptional}
				/>
			</Label>
			{isError && customError && <CustomError modifiers={modifiers}>{customError}</CustomError>}
		</Wrapper>
	)
);

export default Checkbox;
